import App from "../index";
import Scene from "./scene";
import {ResponsiveSize} from "./responsive-watcher";

export default class SceneManager
{

	public app:App;
	public scenes: Scene[];

	constructor(app:App) {
		this.app = app;
		this.scenes = [];

		window.addEventListener('resize', (e) => { this.onResize(); });
		document.addEventListener('responsivechange', (e:CustomEvent) => { this.onResponsiveChange(e.detail.new, e.detail.old); });
	}

	public getScene(sceneClass: typeof Scene):Scene|undefined
	{
		for (let i = 0; i < this.scenes.length; i++)
		{
			if (this.scenes[i] instanceof sceneClass)
			{
				return this.scenes[i];
			}
		}
	}

	public registerScene(sceneClass: typeof Scene, targetContainer: string = ''):Scene {
		const scene = new sceneClass(this, targetContainer);
		this.scenes.push(scene);

		this.app.scroller.addScrollTrigger(
			scene.elContainer,
			scene,
			this.app.responser.isSmallerOrEqualTo(ResponsiveSize.md) ? sceneClass.WINDOW_OFFSET_MOBILE : sceneClass.WINDOW_OFFSET
		);

		scene.onResponsiveChange(this.app.responser.currentSize, this.app.responser.currentSize, this.app.responser);
		
		return scene;
	}

	public onResize():void {
		for (let i = 0; i < this.scenes.length; i++) {
			if (this.scenes[i]) this.scenes[i].onResized();
		}
	}
	
	public onResponsiveChange(newSize:ResponsiveSize, oldSize:ResponsiveSize)
	{
		for (let i = 0; i < this.scenes.length; i++) {
			if (this.scenes[i]) this.scenes[i].onResponsiveChange(newSize, oldSize, this.app.responser);
		}
	}
}
